export default {
  en: {
    title: 'Connect Telegram',
    body: 'Practise in the Telegram bot with the same progress and subscription. Open the bot and tap “Connect”.',
    note: 'You can connect one Telegram account. To change it later, contact support.',
    open: 'Open the bot',
    waiting: 'Tap “Connect” in the bot — this page will update by itself.',
    openAgain: 'Open the bot again',
    linked: 'Telegram is connected',
    taken: 'This Telegram is already connected to another Boltaem account. If that’s a mistake, contact support.',
    alreadyLinked: 'Another Telegram is already connected to this account.',
    error: 'Couldn’t prepare the link.',
    retry: 'Try again',
  },
  ru: {
    title: 'Подключить Telegram',
    body: 'Занимайся в Telegram-боте с тем же прогрессом и подпиской. Открой бота и нажми «Привязать».',
    note: 'Подключить можно один Telegram. Сменить его потом — через поддержку.',
    open: 'Открыть бота',
    waiting: 'Нажми «Привязать» в боте — страница обновится сама.',
    openAgain: 'Открыть бота ещё раз',
    linked: 'Telegram подключён',
    taken: 'Этот Telegram уже привязан к другому аккаунту Boltaem. Если это ошибка — напиши в поддержку.',
    alreadyLinked: 'К этому аккаунту уже подключён другой Telegram.',
    error: 'Не получилось подготовить привязку.',
    retry: 'Повторить',
  },
};
